 <!-- eslint-disable vue/no-unused-vars-->
<template>
  <div class="card">
    <!-- <BlockUI >
      <ProgressSpinner v-if="blockedDocument" />
    </BlockUI> -->
    <div>
    <DataTable
      :value="forms"
      class="p-datatable p-datatable-striped formio-forms"
      :paginator="true"
      sortField="createdDate" 
      :sortOrder="-1"
      :lazy="true"
      :rows="pageSize" 
      :totalRecords="totalItemsCount" 
      @page="onPage($event)"
      @sort="onSort($event)"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[10, 25, 50]"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      dataKey="id"
      :rowHover="true"
      :filters.sync="filters"
      removableSort
       selectionMode="single" 
      :loading="loading"
    >
      <template #header>
        <div class="table-header">
          <h5>Forms</h5>
          <Button
            label="New Form"
            icon="pi pi-plus"
            class="p-button-secondary p-mr-2"
            @click="openappDialog()"
          />
        </div>
      </template>
      <template #loading>
        Loading Arete Application Forms. Please wait.
      </template>
      <template #empty> No Forms found. </template>
      <Column
        field="applicationName"
        header="Application Name"
        filterMatchMode="contains"
        class="p-col"
      >
        <template #filter>
          <Dropdown
            v-model="filters['applicationName']"
            :options="appNames"
            width="30"
            placeholder="Select Application"
            class="p-column-filter filterwidth"
            :showClear="true"
            @change="filterSearch('applicationname')"
            style="width: 100%;"
          >
            <template #option="slotProps">
              <span class="customstatus">{{ slotProps.option }}</span>
            </template>
          </Dropdown>
        </template>
      </Column>
      <Column
        field="name"
        header="Name"
        sortable
        filterMatchMode="contains"
        class="p-col"
      >
        <template #body="slotProps">
          <span
            v-tooltip.bottom="`Description is ${slotProps.data.description}`"
            >{{ slotProps.data.name }}</span
          >
        </template>
        <template #filter>
          <InputText
            type="text"
            v-model="filters['name']"
            class="p-column-filter"
            placeholder="Search by Name"
            v-on:input="filterSearch('name')"
            style="width: 100%;"
          />
        </template>
      </Column>
      <Column field="statusName" header="Form Status" filterMatchMode="equals">
        <template #body="slotProps">
          <div
            :class="'customstatus ' + slotProps.data.statusName.toLowerCase()"
            >{{ slotProps.data.statusName }}</div
          >
          
          <div >
          <Button 
          v-if="slotProps.data.isPublishedForm && slotProps.data.isActive"
           label="View Published Form" 
           class="p-button-link" 
           style="font-size: 12px;padding-right:0px"
           v-tooltip.top="'This form is already Published, Click to view'"
           @click="openpublishedformpreview(slotProps.data,filters)" />
           <Button 
            v-if="slotProps.data.isPublishedForm && !slotProps.data.isActive"
           label="View Published Form" 
           class="p-button-link" 
           style="font-size: 12px;padding-right:0px"
           v-tooltip.top="'No Preview the Published form'"
           @click="openpublishedformpreview(slotProps.data)" disabled />
           <Button 
            v-if="slotProps.data.isPublishedForm && slotProps.data.isActive"
           icon="pi pi-copy"
           class="p-button-link " 
           style="font-size: 12px;margin-bottom:3px!important;margin-left:-7px!important"
           v-tooltip.top="tooltipMsg"
           @click="doCopy(slotProps.data)"
            />
           </div>
        </template>
        
        <template #filter>
          <Dropdown
            v-model="filters['statusName']"
            :options="statuses"
            placeholder="Select a Status"
            class="p-column-filter filterwidth"
            :showClear="true"
            v-on:input="filterSearch('statusname')"
            style="width: 100%;"
          >
            <template #option="slotProps">
              <span :class="'customstatus ' + slotProps.option.toLowerCase()">{{
                slotProps.option
              }}</span>
            </template>
          </Dropdown>
        </template>
      </Column>
      <Column
        field="createdBy"
        header="CreatedBy"
        sortable
        filterMatchMode="contains"
        class="p-col"
      >
        <template #filter>
          <InputText
            type="text"
            v-model="filters['createdBy']"
            class="p-column-filter"
            placeholder="Search by CreatedBy"
            v-on:input="filterSearch('createdby')"
            style="width: 100%;"
          />
        </template>
      </Column>
      <Column
        field="createdDate"
        header="CreatedDate"
        sortable
        filterMatchMode="custom"
        :filterFunction="filterDate"
        class="p-col"
      >
        <template #body="slotProps">
          {{ slotProps.data.createdDate | formatDateTime }}
        </template>
        <template #filter>
          <Calendar
            v-model="filters['createdDate']"
            dateFormat="dd/mm/yy"
            class="p-column-filter"
            placeholder="Created Date"
            :showClear="true"
            :manualInput="false"
            :showButtonBar="true"
            v-on:input="filterSearch('createddate')"
          />
        </template>
      </Column>
      <Column
        field="isActive"
        header="Status"
        sortable
        filterMatchMode="custom"
        :filterFunction="isfilterStatus"
      >
        <template #body="slotProps">
          <span
            :class="
              'customstatus ' +
              (slotProps.data.isActive ? 'Active' : 'Inactive').toLowerCase()
            "
            >{{ slotProps.data.isActive ? "Active" : "Inactive" }}</span
          >
        </template>
        <template #filter>
          <Dropdown
            v-model="filters['isActive']"
            :options="activestatuses"
            placeholder="Select a Status"
            class="p-column-filter"
            :showClear="true"
            @change="filterSearch('isactive')"
            style="width: 100%;"
          >
            <template #option="slotProps">
              <span :class="'customstatus ' + slotProps.option.toLowerCase()">{{
                slotProps.option
              }}</span>
            </template>
          </Dropdown>
        </template>
      </Column>
      <Column header="Actions" class="p-col">
        <template #body="slotProps">
          <Button
            v-if="slotProps.data.statusName.toLowerCase() != `published` && slotProps.data.isActive"
            icon="pi pi-pencil"
            class="p-button-rounded p-button-secondary p-mr-1"
            @click="editForm(slotProps.data)"
            v-tooltip.bottom="'Edit Form Info'"
          />
           <Button
            v-else
            icon="pi pi-pencil"
            class="p-button-rounded p-button-secondary p-mr-1"
            @click="editForm(slotProps.data)"
            v-tooltip.bottom="'Edit Form Info'"
            disabled
          />
          <Button
            v-if="slotProps.data.isActive"
            icon="pi pi-th-large"
            class="p-button-rounded p-button-warning p-mr-1"
            @click="openformbuilder(slotProps.data,filters)"
            v-tooltip.bottom="'Build/Rebuild Form'"
          />
          <Button
            v-else
            icon="pi pi-th-large"
            class="p-button-rounded p-button-warning p-mr-1"
            @click="openformbuilder(slotProps.data,filters)"
            v-tooltip.bottom="'Build/Rebuild Form'"
            disabled
          />
          <Button
            v-if="slotProps.data.schema && slotProps.data.isActive"
            icon="pi pi-eye"
            class="p-button-rounded p-button-help p-mr-1"
            @click="openformpreview(slotProps.data,filters)"
            v-tooltip.bottom="'Preview Form'"
          />
          <Button
            v-if="!slotProps.data.schema || !slotProps.data.isActive"
            icon="pi pi-eye-slash"
            title="No form to preview"
            class="p-button-rounded p-button-help p-mr-1"
            @click="openformpreview(slotProps.data,filters)"
            v-tooltip.bottom="'No form to preview'"
            disabled
          />
          <Button
            v-if="slotProps.data.isActive"
            icon="pi pi-ban"
            class="p-button-rounded p-button-secondary p-mr-1 inactive"
            v-tooltip.bottom="'Deactivate Form'"
            @click="inactiveDialog(slotProps.data)"
          />
          <Button
            v-else
            icon="pi pi-check"
            class="p-button-rounded p-button-secondary p-mr-1 active"
            v-tooltip.bottom="'Activate Form'"
            @click="activeDialog(slotProps.data)"
          />
          <Button
           v-if="slotProps.data.schema && slotProps.data.isActive"
            icon="pi pi-clone"
            class="p-button-rounded p-button-secondary p-mr-1 active"
            v-tooltip.bottom="'Clone Form'"
            @click="openCloneForm(slotProps.data)"
          />
          <Button
            v-if="!slotProps.data.schema || !slotProps.data.isActive"
            icon="pi pi-clone"
            class="p-button-rounded p-button-secondary p-mr-1 active"
            v-tooltip.bottom="'Clone Form'"
            @click="openCloneForm(slotProps.data)"
            disabled
          />
          <!-- <Button
            v-if="slotProps.data.isPublishedForm && slotProps.data.isActive"
            icon="pi pi-file"
            class="p-button-rounded p-button-info p-mr-1"
            @click="openpublishedformpreview(slotProps.data)"
            v-tooltip.bottom="'Preview the Published form'"
          />
          <Button
            v-if="slotProps.data.isPublishedForm && !slotProps.data.isActive"
            icon="pi pi-file"
            class="p-button-rounded p-button-info p-mr-1"
            @click="openpublishedformpreview(slotProps.data)"
            v-tooltip.bottom="'Preview the Published form'"
            disabled
          /> -->
        </template>
      </Column>
    </DataTable>
    <Dialog
      :visible.sync="newFormDialog"
      :header= this.dialogHeader 
      :modal="true"
      :contentStyle="{ overflow: 'visible' }"
      :style="{ width: '50vw' }"
      :autoZIndex="true"
    >
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-12">
          <label for="formTitle"
            >Form Name<span class="p-invalid">*</span
            ></label
          >
          <InputText
            v-model="formDetails.name"
            id="appTitle"
            type="text"
            placeholder="Form Name"
            required="true"
            :class="{ 'p-invalid': submitted && !formDetails.name }"
          />
          <span
              :class="{ 'p-invalid': !formDetails.name }"
              v-if="submitted && !formDetails.name"
              class="error-message"
              >Form Name is Required</span
            >
        </div>
        <!-- <div class="p-field p-col-12 p-md-6">
          <label for="appName" v-tooltip="'Click to proceed'"
            >Form Name<span class="p-invalid">*</span
            >
          </label>
          <InputText
            v-model="formDetails.name"
            id="appName"
            type="text"
            placeholder="Form Name"
            required="true"
            :class="{ 'p-invalid': submitted && !formDetails.name }"
          />
          <span
              :class="{ 'p-invalid': !formDetails.name }"
              v-if="submitted && !formDetails.name"
              class="error-message"
              >Form Name is Required</span
            >
        </div> -->
        <div class="p-field p-col-12 p-md-12">
          <label for="appName" v-tooltip="'Click to proceed'"
            >Select Application<span class="p-invalid">*</span
            >
          </label>
          <Dropdown
            v-model="formDetails.applicationId"
            :options="activeApplications ? activeApplications : applications"
            optionLabel="name"
            placeholder="Select a Application Name"
            scrollHeight = "140px"
            width="30"
            :class="{ 'p-invalid': submitted && !formDetails.applicationId }"
            :filter="true"
          >
            <template #option="slotProps">
              <span
                
                >{{ slotProps.option.name }}</span
              >
              <span
                style="display: none"
                :class="'customstatus ' + slotProps.option.id.toLowerCase()"
                >{{ slotProps.option.id }}</span
              >
            </template>
          </Dropdown>
          <small
            class="p-invalid"
            v-if="submitted && !formDetails.applicationId"
            ></small
          >
          <span
              :class="{ 'p-invalid': !formDetails.applicationId }"
              v-if="submitted && !formDetails.applicationId"
              class="error-message"
              >Application Name is Required</span
            >
        </div>
        <div class="p-field p-col-12">
          <label for="formDescription"
            >Description<span class="p-invalid">*</span
            ></label
          >
          <Textarea
            :autoResize="true"
            rows="3"
            cols="7"
            placeholder="Form Description"
            required="true"
            v-model="formDetails.description"
            :class="{'p-invalid':submitted && !formDetails.description }"
          />
          <span
              :class="{ 'p-invalid': !formDetails.description }"
              v-if="submitted && !formDetails.description"
              class="error-message"
              >Form Description is Required</span
            >
        </div>
      </div>
      <template #footer>
        <Button
          v-if="formDetails.isCloningForm && !formDetails.IsEditMode"
          label="Clone Form"
          icon="pi pi-check"
          class="p-button-text"
          :disabled= "isDisable"
          @click="cloneForm()"
        />
        <Button
          v-else
          label="Save Form"
          icon="pi pi-check"
          class="p-button-text"
          :disabled= "isDisable"
          @click="saveForm()"
        />
        <Button
          label="Cancel" 
          icon="pi pi-times"
          class="p-button-text"
          @click="closeDialog()"
        />
      </template>
    </Dialog>
    <Dialog
      v-if="deleteForm"
      :visible.sync="deleteForm"
      header="Confirmation"
      :modal="true"
      :style="{ width: '30vw' }"
    >
      <div class="p-fluid p-grid">
        <div class="confirmation-content">
          
          <span>{{ selectedForm.dialogContent }}</span>
        </div>
      </div>
      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          @click="closeDialog()"
          class="p-button-text"
        />
        <Button
          label="Yes"
          icon="pi pi-check"
          @click="activedeactiveForm()"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>
    <Sidebar v-if="formBulderPanel" :visible.sync="formBulderPanel" :baseZIndex="1000" position="full" :showCloseIcon="false">
    <div class="p-grid">
                <div class="p-col-3">
                  <span class="m-0 p-0">
                    <Button
            label="Back to Forms"
            icon="pi pi-arrow-left"
            class="p-button-link p-mr-2"
            @click="backto()"
          />
          </span>
      </div>
      <div class="p-col-6">
          <h3 class="text-center">Form Builder</h3>
        </div>
      </div>
    <FormBuilder />
    </Sidebar>
    <Sidebar v-if="formPreviewPanel" :visible.sync="formPreviewPanel" :baseZIndex="1000" position="full" :showCloseIcon="false">
      <div class="p-grid">
                <div class="p-col-3">
                  <span class="m-0 p-0">
                    <Button
            label="Back to Forms"
            icon="pi pi-arrow-left"
            class="p-button-link p-mr-2"
            @click="backto()"
          />
          </span>
      </div>
      <div class="p-col-6">
          <h3 class="text-center">Form Preview</h3>
        </div>
      </div>
    <FormPreview />
    </Sidebar>
    <Sidebar v-if="publishedFormPanel" :visible.sync="publishedFormPanel" :baseZIndex="1000" position="full" :showCloseIcon="false">
    <div class="p-grid">
                <div class="p-col-3">
                  <span class="m-0 p-0">
                    <Button
            label="Back to Forms"
            icon="pi pi-arrow-left"
            class="p-button-link p-mr-2"
            @click="backto()"
          />
          </span>
      </div>
      <div class="p-col-6">
          <h3 class="text-center">Published Form Preview</h3>
        </div>
      </div>
    <PublishedForm />
    </Sidebar>
</div>
  </div>
</template>

<script>
import moment from "moment";
import _ from "lodash";
import FormBuilder from '@/components/formio/FormBuilder.vue';
import FormPreview from '@/components/formio/FormPreview.vue';
import PublishedForm from '@/components/formio/PublishedForm.vue';

export default {
  name: "formsComponents",
  watch: {},
  data() {
    return {
      forms: null,
      blockedPanel: false,
      blockedDocument: false,
      filters: {},
      newFormDialog: false,
      formDetails: {},
      submitted: false,
      loading: false,
      statuses: [
        "Draft",
        "Submitted For Review",
        "Published",
        "Publish Pending",
      ],
      activestatuses: ["Active", "Inactive"],
      applications: [],
      selectedForm: null,
      deleteForm: false,
      form_error: false,
      appNames: [],
      selectedFilters: {},
      selectedFiltersStore: null,
      totalItemsCount: null,
      pageSize : 10,
      selectedPageNo : null,
      selectedPageSize: null,
      appliedFilters: null,
      isEditing: false,
      pageReloadCount: 0,
      pageNumber: null,
      visibleFull: false,
      formBulderPanel: false,
      formPreviewPanel: false,
      publishedFormPanel: false,
      cloneFormPanel: false,
      dialogHeader: null,
      activeApplications: null,
      globalPageNo: null,
      href_url: window.location.href,
      tooltipMsg: 'Copy form Path',
      isFilterApplied : false,
      isDisable: false
    };
  },
  created() {
    this.getAppsData();
    let filters = this.$store.getters["forms/getFilters"];
     let appData = _.filter(this.$store.getters["forms/getApplicationsData"],t => t.name == filters.applicationName);
    let input = {
      startPageNo : filters.pagedNo == undefined ? 1 : filters.pagedNo,
      recordsPerPage : this.pageSize,
      filters : {
                title : filters.title == undefined ? null : filters.title,
                name : filters.name == undefined ? null : filters.name,
                applicationName : filters.applicationName == undefined ? null : appData[0].id,
                createdBy : filters.createdBy == undefined ? null : filters.createdBy,
                createdDate : filters.createdDate == undefined ? null : filters.createdDate,
                status : filters.statusName == undefined ? -1 : filters.statusName.replace(/\s+/g, ''),
                isActiveForm : filters.isActive == undefined ? null : filters.isActive == "Active" ? true : false,
              },
      sortOrder: {
          columnName: "createdDate",
          direction: -1,
        },
    }
    this.getPaginatedForms(input);
  },
  methods: {
    doCopy: function (data) {
      let that = this;
         that.$root.$emit("doCopy", data)
      },
    backto() {
      this.formPreviewPanel = false;
      this.formBulderPanel = false;
      this.publishedFormPanel = false;
    },
    filterSearch(ctrl){
      // console.log(ctrl);
      this.isFilterApplied = true;
       setTimeout(() => this.onPage(ctrl), 1000);
       this.selectedPageNo = "";
       this.selectedPageSize = "";
    },
    onSort(event) {
      setTimeout(() => this.onPage(event), 1000);
    },
    onPage(event) {
      this.loading = true;
      let appData = _.filter(this.$store.getters["forms/getApplicationsData"],t => t.name == this.filters.applicationName);
      let input = {
        startPageNo : event.page + 1 ? event.page + 1 : 1,
        recordsPerPage : event.rows ? event.rows : this.pageSize,
        filters : {
          title : this.filters.title == undefined ? null : this.filters.title,
          name : this.filters.name == undefined ? null : this.filters.name,
          applicationName : this.filters.applicationName == undefined ? null : appData[0].id,
          createdBy : this.filters.createdBy == undefined ? null : this.filters.createdBy,
          createdDate : this.filters.createdDate == undefined ? null : this.filters.createdDate,
          status : this.filters.statusName == undefined ? -1 : this.filters.statusName.replace(/\s+/g, ''),
          isActiveForm : this.filters.isActive == undefined ? null : this.filters.isActive == "Active" ? true : false,
        },
        sortOrder: {
          columnName: event.sortField ? event.sortField : "createdDate",
          direction: event.sortOrder ? event.sortField != "isActive" ? (event.sortOrder == 1 ? 0 : 1) : (event.sortOrder == 1 ? 1 : 0) : 1,
        },
        type : ''
      }
      this.selectedPageNo = input.startPageNo ? input.startPageNo : 1 ;
      this.selectedPageSize = input.recordsPerPage ? input.recordsPerPage : this.pageSize;
      this.pageSize = this.selectedPageSize;
      this.globalPageNo = this.selectedPageNo;
      this.getPaginatedForms(input);
    },

    getPaginatedForms(input) {
      let that = this;
      that.selectedFiltersStore = "";
      this.blockedDocument = true;
      that.loading = true;
      this.$store
        .dispatch("forms/getPagingForms", input)
        .then(() => {
          that.forms = that.$store.getters["forms/getForms"]; 
          that.totalItemsCount = that.forms.totalRecords;
          that.first = that.forms.pageNo;     
          that.blockedDocument = false;
          that.loading = false;
          that.selectedPageNo = "";
          that.selectedPageSize = "";
          // if(!this.isFilterApplied){
          //   this.filters.createdDate = "";
          // }
        })
        .catch((error) => {
          this.$toast.add({
            severity: "error",
            summary: "Error while fetching forms",
            detail: error.response,
            life: 3000,
          });
          that.loading = false;
             that.blockedDocument = false;
        });
    },

    getForms() {
      let that = this;
      that.selectedFiltersStore = "";
     // this.$store.commit("forms/clearFilters","");
      this.blockedDocument = true;
      that.loading = true;
      this.$store
        .dispatch("forms/getAllForms")
        .then(() => {
          that.forms = that.$store.getters["forms/getForms"];
          that.blockedDocument = false;
          that.loading = false;
        })
        .catch((error) => {
          this.$toast.add({
            severity: "error",
            summary: "Error while fetching forms",
            detail: error.response.data,
            life: 3000,
          });
          that.loading = false;
             that.blockedDocument = false;
        });
    },

    getAppsData(){
      let that = this;
      that.applications = [];
      this.$store
      .dispatch("forms/getApplications")
      .then(() => {
        let apps = that.$store.getters["forms/getApplicationsData"];
        apps.forEach((item) => that.applications.push(item));
        that.appNames = _.clone(_.map(that.applications, (x) => x.name));
      })
      .catch((error) => {
        this.$toast.add({
          severity: "error",
          summary: "Error while fetching applications",
          detail: error.response.data,
          life: 3000,
        });
      });
    },

    validateFrom() {
      let app = this.formDetails;
      app.title = app.title == "" ? null : app.title;
      if (!_.includes(app, "") && Object.keys(app).length > 3) {
        this.form_error = true;
      } else {
        this.form_error = false;
      }
    },

    openappDialog() {
      this.isDisable = false;
      this.formDetails = {};
      this.newFormDialog = true;
      this.dialogHeader = 'New Form';
      this.activeApplications = _.clone(_.filter(this.applications, a => a.isActive));
    },

    closeDialog() {
      this.newFormDialog = false;
      this.submitted = false;
      this.deleteForm = false;
      this.blockedDocument = false;
    },

    getCurrentPagedForms(){
      let input = {
              startPageNo : this.selectedPageNo ? this.selectedPageNo : this.globalPageNo ? this.globalPageNo : 1,
              recordsPerPage : this.selectedPageSize ? this.selectedPageSize : this.pageSize,
              filters : {
                title : this.appliedFilters.title == undefined ? null : this.appliedFilters.title,
                name : this.appliedFilters.name == undefined ? null : this.appliedFilters.name,
                applicationName : this.appliedFilters.applicationName == undefined ? null : this.appliedFilters.applicationName,
                createdBy : this.appliedFilters.createdBy == undefined ? null : this.appliedFilters.createdBy,
                createdDate : this.appliedFilters.createdDate == undefined ? null : this.appliedFilters.createdDate,
                status : this.appliedFilters.statusName == undefined ? -1 : this.appliedFilters.statusName.replace(/\s+/g, ''),
                isActiveForm : this.appliedFilters.isActive == undefined ? null : this.appliedFilters.isActive == "Active" ? true : false,
              },
              sortOrder: {
                columnName: "createdDate",
                direction:  1,
              },
            }
        this.getPaginatedForms(input);
    },

    saveForm() {
      let that = this;
      that.validateFrom();
      that.submitted = true;
      let input = that.formDetails;
      if (this.form_error) {
        this.loading = true;
        this.isDisable = true;
        that.newFormDialog = false;
        input.createdBy = this.$store.getters["login/getUsername"];
        input.application = input.application?.id == input.applicationId?.id ? input.application : input.applicationId;
        input.applicationId = that.formDetails.application ? that.formDetails.application.id : that.formDetails.applicationId;
        that.$store
          .dispatch("forms/saveForm", input)
          .then(() => {
            let formData = that.$store.getters["forms/getForms"];
            that.newFormDialog = false;
            
            that.submitted = false;
            that.$store.commit("forms/setSelectedForm", formData);
            if(!input.IsEditMode){
            that.$router.push(`formbuilder/${formData.id}`);
            } 
            // else if(input.isCloningForm){
            //   that.formBulderPanel = true;
            //   let selectedform = formData;
            //   that.$store.commit("forms/setSelectedForm", selectedform);
            // } 
             else{
              this.$toast.add({
              severity: "success",
              summary: "Update Form",
              detail: "Form updated successfully",
              life: 3000,
            });
            that.getCurrentPagedForms();
            }
            that.formDetails = {};
            that.blockedDocument = false;
            this.loading = false;
            // that.$store.commit("forms/setSelectedForm", "");
          })
          .catch(() => {
            this.$toast.add({
              severity: "error",
              summary: "Error while save/update Form",
              detail: "Form Name " + input?.name +  " already exists with the Application " + input.application?.name,
              life: 3000,
            });
          that.submitted = false;
          that.blockedDocument = false; 
          this.loading = false;
          });
      }
    },

    cloneForm() {
      let that = this;
      that.submitted = true;
      that.isDisable = false;
      that.validateFrom();
      let input = that.formDetails;
      if (this.form_error) {
        that.newFormDialog = false;
        that.loading = true;
        input.createdBy = this.$store.getters["login/getUsername"];
        input.applicationId = that.formDetails.applicationId.id ? that.formDetails.applicationId.id : that.formDetails.applicationId;
        that.$store
          .dispatch("forms/cloneForm", input)
          .then(() => {
            let formData = that.$store.getters["forms/getForms"];
            that.newFormDialog = false;
            that.submitted = false;
            that.$router.push(`formbuilder/${formData.id}`);
            that.formDetails = {};
            that.$store.commit("forms/setSelectedForm", formData);
            that.formBulderPanel = true;
            that.blockedDocument = false;
            that.loading = false;
          }).catch((error) => {
            console.log(error);
            this.$toast.add({
              severity: "error",
              summary: "Form Name " + input.name + " already exists with the selected Application ",
              detail: error.response,
              life: 3000,
            });
          that.blockedDocument = false; 
          that.loading = false;
          });
      }
    },

    filterDate(value, filter) {
      if (
        filter === undefined ||
        filter === null ||
        (typeof filter === "string" && filter.trim() === "")
      ) {
        return true;
      }

      if (value === undefined || value === null) {
        return false;
      }
      value = moment(value).format("DD/MM/YYYY");
      filter = moment(filter).format("DD/MM/YYYY");
      return value === filter;
    },

    editForm(form) {
      let that = this;
      this.isDisable = false;
      that.dialogHeader = "Edit Form"
      let formdata = _.clone(form);
      that.newFormDialog = true;
      that.activeApplications = null;
      formdata.IsEditMode = true;
      _.forEach(this.applications, function (item) {
        if (item.id == formdata.applicationId) {
          formdata.applicationId = item;
          formdata.application = item;
        }
      });
      that.formDetails = formdata;
      that.appliedFilters = that.filters;
    },

    filterStatus(rowValue, filterValue) {
      if (filterValue == null) return rowValue || !rowValue;
      return filterValue == "Draft" ? rowValue : !rowValue;
    },

    isfilterStatus(rowValue, filterValue) {
      if (filterValue == null) return rowValue || !rowValue;
      return filterValue == "Active" ? rowValue : !rowValue;
    },

    formatStatus(value) {
      return value == 0
        ? "Draft"
        : value == 1
        ? "SubmittedForReview"
        : value == 2
        ? "PublishPending"
        : "Published";
    },

    openformbuilder(form,filters) {
      // this.loading = true;
      let that = this;
      that.formBulderPanel = true;
      let selectedform = form;
      this.$store.commit("forms/setSelectedForm", selectedform);
      let pagedFilters = filters;
      let filtersStore = this.$store.getters["forms/getFilters"];
      pagedFilters.pagedNo = this.globalPageNo == null ? filtersStore.pagedNo == null ? 1 : filtersStore.pagedNo : this.globalPageNo;
      this.$store.commit("forms/setFilters", pagedFilters);
      that.$router.push(`formbuilder/${selectedform.id}`);
      this.blockedDocument = false;
      that.selectedFilters = filters;
      this.visibleFull = true;      
    },

    openformpreview(form,filters) {
      let that = this;
      that.formPreviewPanel = true;
      let selectedform = form;
      this.$store.commit("forms/setSelectedForm", selectedform);
      let pagedFilters = filters;
      let filtersStore = this.$store.getters["forms/getFilters"];
      pagedFilters.pagedNo = this.globalPageNo == null ? filtersStore.pagedNo == null ? 1 : filtersStore.pagedNo : this.globalPageNo;
      this.$store.commit("forms/setFilters", pagedFilters);
      that.$router.push(`formpreview/${selectedform.id}`);
        this.blockedDocument = false; 
    },
   
   openpublishedformpreview(form,filters){
     this.selectedFilters = "";
      let that = this;
      let selectedform = form;
      let formId=_.clone(selectedform.id).trim();
      let applicationId=_.clone(selectedform.applicationId).trim();
     that.$router.push(`form/${applicationId}/${formId}`);
    //  let routeData = that.$router.resolve(`form/${applicationId}/${formId}`);
    //   window.open(routeData.href, '_blank');
    let pagedFilters = filters;
    let filtersStore = this.$store.getters["forms/getFilters"];
    pagedFilters.pagedNo = this.globalPageNo == null ? filtersStore.pagedNo == null ? 1 : filtersStore.pagedNo : this.globalPageNo;
    this.$store.commit("forms/setFilters", pagedFilters);
      this.$store.commit("forms/setSelectedForm", selectedform);
        this.blockedDocument = false;
        that.selectedFilters = filters;
        this.$store.commit("forms/setSelectedFilters", that.selectedFilters);
        // console.log(filters);
        this.publishedFormPanel= true;
    },
   
   inactiveDialog(form) {
      let that = this;
      let formDetails = form;
      formDetails.dialogContent = `Are you sure, you want to Deactivate the ${form.name} ? `;
      formDetails.toastAlert = 'Deactivated';
      that.selectedForm = _.clone(formDetails);
      that.deleteForm = true;
    },

    activeDialog(form) {
      let that = this;
      let formDetails = form;
      formDetails.dialogContent = `Are you sure, you want to Activate the ${form.name} ? `;
      formDetails.toastAlert = 'Activated';
      that.selectedForm = _.clone(formDetails);
      that.deleteForm = true;
    },

    activedeactiveForm() {
      let that = this;
      let input = that.selectedForm;
      input.formid = input.id;
      that.appliedFilters = that.filters;
      this.$store
        .dispatch("forms/activedeactiveForm", input)
        .then(() => {
          that.deleteForm = false;
          this.$toast.add({
            severity: "success",
            summary: that.selectedForm.toastAlert + " Form",
            life: 1000,
          });
          that.getCurrentPagedForms();
        })
        .catch((error) => {
          this.$toast.add({
            severity: "error",
            summary: "Error while updating the application from",
            detail: error,
            life: 3000,
          });
        });
    },

    openCloneForm(form){
      let that = this;
      that.dialogHeader = 'Clone Form'
      let formdata = _.clone(form);
      that.newFormDialog = true;
      that.activeApplications = null;
      _.forEach(this.applications, function (item) {
        if (item.id == formdata.applicationId) {
          formdata.applicationId = item;
        }
      });
      that.formDetails = formdata;
      that.formDetails.isCloningForm = true;
      that.formDetails.title = "";
      that.formDetails.name = "";
      that.formDetails.description = "";
      that.formDetails.id = null;
      that.appliedFilters = that.filters;
    }
  },
  props: {},
  components: {
      'FormBuilder': FormBuilder,
      'FormPreview' : FormPreview,
      'PublishedForm' : PublishedForm
  }
};
</script>

<style scoped>
.active {
  background-color: #c8e6c9 !important;
  color: #256029 !important;
  border: #c8e6c9 !important;
}
.filterwidth{
  width: 160px;
}
</style>